<template>
  <!-- <card :header-text="'Raw Data '+ company.companyname"> -->
  <div class="card" v-if="comp">
    <div class="table-responsive app" v-dragscroll="true">
      <table :id="rdType" class="table table-bordered fonts11 app-inner">
        <tr v-for="(rd, index) in rawdata" v-bind:key="'td' + index">
          <th>
            {{ index + 1 }}.
            <!-- <a
              class="btn btn-sm"
              @click="showDetails(index)"
            >{{rd.caption}} - {{rd.date}}</a> -->
            <a class="btn btn-sm" style="font-weight:bold;cursor: default;">{{ rd.caption }} - {{ rd.date }}
            </a>
            <p style="margin-left: 21px;margin-bottom:0;font-size:14px;color:#212529;" v-html="rd.memo"></p>

          </th>
        </tr>
      </table>
    </div>
    <newsDetails :show.sync="show" ref="smallModal" v-bind:large="true" :cancelClass="'btn btn-secondary'"
      :respData="nDetails" :cancelDetails="cancelNewsDetails"></newsDetails>
  </div>
</template>
<script>
import http from "@/lib/http";

import { commonMixins } from "../../../assets/mixins/common.js";
import { rawMixins } from "../../../assets/mixins/rawMixins.js";
import newsDetails from "@/components/newsDetails.vue";
export default {
  props: ["newsData", "comp", "rdType", "columns", "rows"],
  mixins: [commonMixins, rawMixins],
  components: { newsDetails },
  created() { },
  methods: {
    showDetails(ind) {
      http.post(
        "rawDataList",
        {
          rowFieldName: "company_news_details",
          co_code: this.comp.co_code,
          sr_no: this.rawdata[ind].sr_no
        },
        (error, response) => {
          console.log("Response", response.data);
          if (response.data && response.data.length > 0) {
            this.nDetails = response.data[0];
            this.$refs.smallModal.open();
          } else {
            this.$toastr.error('Oops, something went wrong! Please try again later.', '', {});
          }
        }
      );
    },
    cancelNewsDetails() {
      console.log("Emitted modal");
      this.nDetails = {};
    }
  },
  data() {
    return {
      rawdata: [],
      show: false,
      nDetails: {}
    };
  },
  watch: {
    newsData: function (value) {
      console.log("# NEWS: ", this.newsData, value);
      this.rawdata = value;
    }
  },
  computed: {}
};
</script>



// WEBPACK FOOTER //
// src/views/company/rawdata/company-news.vue